// tslint:disable:max-line-length

export const USE_MOCK_RESPONSE = false;

export const vouchersResponse = {
    "vouchers": [
        {
            "id": "iudqq2xg3tnoonbzm6aguxig",
            "purchaseValue": {
                "amount": 1100,
                "currency": "EUR" as "EUR"
            },
            "exchangeValue": {
                "amount": 1200,
                "currency": "EUR" as "EUR"
            },
            "campaignName": "Voucher Campaign",

            "logoURL": "https://cdn0.erstegroup.com/content/sites/at/eh/www_erstegroup_com/de/ueber-uns/tochtergesellschaften/erste-group-services/_jcr_content/mainParsys/sectionwithheadline/items/textwithimage_1/image.fitIn.w950.png/15541142296631554114063405.png",
            "mobileLogoURL": "https://cdn0.erstegroup.com/content/sites/at/eh/www_erstegroup_com/de/ueber-uns/tochtergesellschaften/erste-group-services/_jcr_content/mainParsys/sectionwithheadline/items/textwithimage_1/image.fitIn.w950.png/15541142296631554114063405.png",
            "redeemCodes": [
                {
                    "code": "123"
                },
                {
                    "pin": "234"
                },
                {
                    "url": "https://vouchers.example/?code=123" // https://s1.q4cdn.com/806093406/files/doc_downloads/test.pdf can be used for testing with no cors enabled
                }
            ],
            "redeemURL": "https://redeem.url?id=123",
            "purchasedAt": "2016-02-05T14:35:33Z",
            "referenceID": "5lonmxgt"
        },
        {
            "id": "ddkadflkasfhlgasdf",
            "purchaseValue": {
                "amount": 500,
                "currency": "EUR" as "EUR"
            },
            "exchangeValue": {
                "amount": 600,
                "currency": "EUR" as "EUR"
            },
            "campaignName": "Voucher Campaign",

            "logoURL": "https://cdn0.erstegroup.com/content/sites/at/eh/www_erstegroup_com/de/ueber-uns/tochtergesellschaften/erste-group-services/_jcr_content/mainParsys/sectionwithheadline/items/textwithimage/image.fitIn.w950.png/15353592176711454941370804.png",
            "mobileLogoURL": "https://cdn0.erstegroup.com/content/sites/at/eh/www_erstegroup_com/de/ueber-uns/tochtergesellschaften/erste-group-services/_jcr_content/mainParsys/sectionwithheadline/items/textwithimage/image.fitIn.w950.png/15353592176711454941370804.png",
            "redeemCodes": [
                {
                    "code": "123"
                },
                {
                    "pin": "234"
                },
                {
                    "url": "https://vouchers.example/?code=123"
                }
            ],
            "redeemURL": "https://redeem.url?id=123",
            "purchasedAt": "2016-02-05T14:35:33Z",
            "referenceID": "qwerqwer"
        }
    ]
};

export const singleVoucherResponse = {
    "id": "iudqq2xg3tnoonbzm6aguxig",
    "purchaseValue": {
        "amount": 1100,
        "currency": "EUR" as "EUR"
    },
    "exchangeValue": {
        "amount": 1200,
        "currency": "EUR" as "EUR"
    },
    "campaignName": "Voucher Campaign",
    "logoURL": "https://cdn0.erstegroup.com/content/sites/at/eh/www_erstegroup_com/de/ueber-uns/tochtergesellschaften/erste-group-services/_jcr_content/mainParsys/sectionwithheadline/items/textwithimage_1/image.fitIn.w950.png/15541142296631554114063405.png",
    "mobileLogoURL": "https://cdn0.erstegroup.com/content/sites/at/eh/www_erstegroup_com/de/ueber-uns/tochtergesellschaften/erste-group-services/_jcr_content/mainParsys/sectionwithheadline/items/textwithimage_1/image.fitIn.w950.png/15541142296631554114063405.png",
    "redeemCodes": [
        {
            "code": "123"
        },
        {
            "pin": "234"
        },
        {
            "url": "https://vouchers.example/?code=123"
        }
    ],
    "redeemURL": "https://redeem.url?id=123",
    "purchasedAt": "2016-02-05T14:35:33Z",
    "faq": [
        {
            "question": "Question text",
            "answer": "Answer text",
            "icon": "https://icons.com/example.png"
        }
    ],
    "referenceID": "5lonmxgt"
};

export const shopAccessResponse = {
    "url": "https://example.com/"
};




// WEBPACK FOOTER //
// ./src/components/optiopay/OptioPayMockAPI.ts